<template>
	<div id="List">
		<!-- banner -->
		<div v-if='!Nav.lanmu.Logo && !Nav.PColumn || Nav.lanmu.Logo =="http://base.hope55.com" && Nav.PColumn.Logo == "http://base.hope55.com"' class="banner"></div>
		<div v-else-if="Nav.lanmu.Logo==''&& !Nav.PColumn==''" class="banner"></div>
		<div v-else class="banner" :style="{'background-image': 'url('+( Nav.lanmu.Logo ? Nav.lanmu.Logo : Nav.PColumn.Logo )+')'}"></div>
		<!-- 导航 -->
		<div class="navList">
			<div class="clearfix">
				<div class="topDh">
					<!-- 当前位置 -->
					<address-bar :addressBarData="Nav"></address-bar>
				</div>
				<div class="main w69">
					<div id="infoBox">
						<div v-if="NId" class="newsDetails">
							  <template>
									<p class="title">{{List.Title}}</p>
									<p class="related_information">
									  <span>时间：{{List.ShowTime}}</span>
									  <span>浏览次数：{{List.Press}}</span>
									</p>
							  </template>
						  <div class="info" v-html="List.Details"></div>
					   </div>
					   <div v-else-if="HType==1" v-html="List.Info"  class="singleBox"></div>
					   <component-view  v-else  :option='{dataList: List ,componentType: currentValue}' ></component-view>
					   <!-- 分页 -->
					   <page-box :pageBoxData="List.PageBar" :pageIndex="PageIndex"></page-box>
					   <!-- <div class="paging" id="page_turn_box">
							<a href="">首页</a>
							<a href="">上一页</a>
							<a href="" class="on">1</a>
							<a href="">2</a>
							<a href="">3</a>
							<a href="">下一页</a>
							<a href="">末页</a>
              			</div> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import '../assets/css/list.css';
	import addressBar from '@/components/addressBar'
	import pageBox from '@/components/pageBox'
	import componentView from '../components/componentView'
	export default{
		name:'list',
		components:{
			addressBar,
			pageBox,
			componentView
		},
		data(){
			return{
			   CId:this.$route.query.CId,
			   NId:this.$route.query.NId,
			   PageIndex:this.$route.query.PageIndex,
			   HType:this.$route.query.HType,
			   Nav:'',
			   item:'',
			   List:[],
			   currentData: '',
       		   currentValue: 'pageBox'
			}
		},
		created(){
			this.Nav = this.Curren.SetClassStyle(this.CId);
			this.Nav.List=[];
			this.Nav.lanmu.Fid > 0?this.Nav.List = this.$root.$children['0'].$children['0'].menuListOne.filter(ele=> ele.ID==this.Nav.lanmu.Fid)[0].Children : this.Nav.List.push(this.Nav.lanmu)
			if( this.$root.$children['0'].$children['0'].menuListOne){
				this.$root.$children['0'].$children['0'].menuListOne.forEach(element => { // 确定菜单点击项
			        element.ID == this.CId ? element.On = true : element.On = false
			    });
			}
			if(this.NId){//详情
				this.List = this.Base.GetNewsInfoByNid(this.NId);
			}else if(this.HType==1){
				this.List = this.Base.GetSinglePageInfoByCid(this.CId);
				// console.log(this.List)
			}else{
				if(this.CId == 6279 || this.CId == 6280 || this.CId == 6282 || this.CId == 6283 || this.CId == 6284 || this.CId == 6285) {//无图 新闻列表
					this.List = this.Base.GetNewsInfoByCid(this.CId,false,this.PageIndex,'',4);
					this.currentValue = 'downList';
				}
				else if(this.CId == 6584){//带图 新闻列表
					this.List = this.Base.GetNewsInfoByCid(this.CId,false,this.PageIndex,'',4);
					this.currentValue = 'noImgList2';
				}
				else if(this.CId == 6286){ //文件 常用下载
					this.List = this.Base.GetFilesInfoByCid(this.CId,this.PageIndex, '', 7,'');
					this.currentValue = 'noImgList';
				}
				//  console.log(this.Nav,'nav');
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/list.vue